<script setup lang="ts">
import MobileModal from '@consumer/modules/v2/layout/Header/UserMenu/MobileModal.vue'
import type { CurrentUser } from '@consumer/types/serializers'
import BuyAGift from './UserMenu/BuyAGift.vue'
import Menu from './UserMenu/Menu.vue'
import MenuButton from './UserMenu/MenuButton.vue'
import ProfilePanel from './UserMenu/ProfilePanel.vue'

const currentUser = inject<Ref<CurrentUser | null>>('currentUser')

const open = ref(false)
</script>

<template>
  <div>
    <div
      class="relative inline-block text-left"
      @click="open = !open"
    >
      <MenuButton v-model:open="open"/>
    </div>

    <MobileModal v-model:open="open">
      <div v-if="currentUser" class="flex flex-col">
        <ProfilePanel layout="mobile" class="rounded-tl-v2lg"/>
        <div class="px-4 pb-4">
          <Menu v-model:open="open"/>
        </div>
      </div>
      <div v-else class="p-4 pt-v2-10 flex flex-col">
        <Menu v-model:open="open"/>
        <div class="flex-1">
          <BuyAGift style=" height: 100%; min-height: 320px;width: 100%;"/>
        </div>
      </div>
    </MobileModal>
  </div>
</template>
